import { history } from '@umijs/max';
import { ACCESS_TOKEN_KEY, EXPIRES_IN_KEY, LOGIN_PATH } from './constants';

export function clearStorage() {
  localStorage.removeItem(EXPIRES_IN_KEY);
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}
/*
  * Check if the token is expired or exists
  * @returns {boolean} true if the token is expired, false otherwise
  */
export function isTokenValid(): boolean {
  const storedAccessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (!storedAccessToken) {
    return false;
  }

  const storedExpiresIn = localStorage.getItem(EXPIRES_IN_KEY);
  if (!storedExpiresIn || isNaN(Number(storedExpiresIn))) {
    return false;
  }
  const expiresIn = parseInt(storedExpiresIn, 10);
  return Date.now() < expiresIn;
};

export function handleTokenExpiration() {
  clearStorage();

  if (history.location.pathname !== LOGIN_PATH) {
    history.push(LOGIN_PATH);
  }
};

export enum CryptoTokenType {
  TRX = 'TRX',
  USDT = 'USDT',
  USDC = 'USDC',
}

export enum WithdrawRequestStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

const tokenDecimalMultipliers: Record<CryptoTokenType, number> = {
  [CryptoTokenType.USDT]: 1e6,
  [CryptoTokenType.TRX]: 1e6,
  [CryptoTokenType.USDC]: 1e6,
};

export function getTokenDecimalMultiplier(token: CryptoTokenType): number {
  return tokenDecimalMultipliers[token] || 1;
}

export function truncateHash(hash: string) {
  return `${hash.slice(0, 6)}...${hash.slice(-4)}`;
}

export function getBlockExplorerLink(hash: string) {
  return hash.startsWith('0x')
    ? `https://etherscan.io/tx/${hash}`
    : `https://tronscan.org/#/transaction/${hash}`;
}
